// src/components/DevStream/EventCardSummary.js
import React from "react";
import "./DevStream.css";

/**
 * EventCardSummary - Always-visible key fields section
 *
 * Displays extracted metadata:
 * - Device ID
 * - Installation ID
 * - Action ID
 * - Action Status
 * - Trait Name
 * - Credential ID
 */
const EventCardSummary = ({
  deviceId,
  subscriptionInstallationId,
  installationId,
  actionId,
  actionStatus,
  traitName,
  credentialId,
}) => {
  return (
    <div className="event-card-summary">
      {deviceId !== "N/A" && (
        <div className="summary-field">
          <span className="field-label">Device:</span>
          <span className="field-value">{deviceId}</span>
        </div>
      )}

      {subscriptionInstallationId && (
        <div className="summary-field">
          <span className="field-label">Site:</span>
          <span className="field-value">{subscriptionInstallationId}</span>
        </div>
      )}

      {installationId && !subscriptionInstallationId && (
        <div className="summary-field">
          <span className="field-label">Site:</span>
          <span className="field-value">{installationId}</span>
        </div>
      )}

      {actionId && (
        <div className="summary-field">
          <span className="field-label">Action:</span>
          <span className="field-value">{actionId}</span>
        </div>
      )}

      {actionStatus && (
        <div className="summary-field">
          <span className="field-label">Status:</span>
          <span className="field-value">{actionStatus}</span>
        </div>
      )}

      {traitName && (
        <div className="summary-field">
          <span className="field-label">Trait:</span>
          <span className="field-value">{traitName}</span>
        </div>
      )}

      {credentialId && (
        <div className="summary-field">
          <span className="field-label">Credential:</span>
          <span className="field-value">{credentialId}</span>
        </div>
      )}
    </div>
  );
};

export default EventCardSummary;
